module.exports = __webpack_public_path__ + "img/IEC13855.ac451de8.png";